export default __webpack_public_path__ + "d5bf5d5392db9bb15e60a642e10719ca.svg";